<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="creatTime"
              class="el_date_picker"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机构编号" v-if="isInstitution">
            <el-input placeholder="请输入机构编号" clearable v-model="customerId"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 120px;" v-model="status" clearable>
              <!-- <el-option label="未审核" value="0"></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="审核退回" value="2"></el-option>
              <el-option label="资料待完善" value="3"></el-option> -->
              <el-option label="待审核" value="1"></el-option>
              <el-option label="审核通过" value="2"></el-option>
              <el-option label="已拒绝" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button opt="export" :plain="true" @click.native="exportInvoice" label="导出" :loading="exportLoading"></auth-button>
            <auth-button opt="entry_invoice" :plain="!isInstitution" @click.native="invoiceEntryCilck" label="发票录入"></auth-button>
            <auth-button opt="batch_import" @click.native="multiInvoiceEntry" label="批量导入" v-if="!isInstitution"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 合计 -->
      <el-col>
        <el-form :inline="true">
          <el-form-item label="合计" style="font-weight: bold;"></el-form-item>
          <el-form-item label="申请发票面值：">{{ totalAmountCount.totalInpAmount }}</el-form-item>
          <el-form-item label="审核发票面值：">{{ totalAmountCount.totalAudtiAmount }}</el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 发票信息table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="invoiceList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="机构编号"
          v-if="isInstitution"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentName"
          label="机构名称"
          v-if="isInstitution"
          align="center">
        </el-table-column>
        <el-table-column
          prop="invoiceNo"
          label="发票号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="invoiceAmountStr"
          label="申请发票面值"
          align="center">
        </el-table-column>
        <el-table-column
          prop="auditAmountStr"
          label="审核发票面值"
          align="center">
        </el-table-column>
        <el-table-column
          prop="statusStr"
          label="状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              v-if="scope.row.fState !== 3"
              @click.native="handleCheck(scope.$index, scope.row)"
              label="查看"></auth-button>
            <auth-button
              opt="edit"
              type="text"
              v-if="scope.row.fState === 3"
              @click.native="handleEdit(scope.$index, scope.row)"
              label="编辑"></auth-button>
            <auth-button
              opt="delete"
              type="text"
              v-if="scope.row.fState === 3"
              label="删除"
              @click.native="handleRemove(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!-- 发票录入和查看dialog -->
    <el-dialog
      v-if="invoiceInfoDialogVisible"
      :title="isInvoiceInfoEditeDisable ? (isCheck?'查看发票信息':'编辑发票信息') : '发票录入'"
      :visible.sync="invoiceInfoDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      @close="$refs['invoiceInfoform'].resetFields()">
      <div v-loading="invoiceInfoDialogLoading">
        <el-form ref="invoiceInfoform" :rules="invoiceInfoRules" :model="invoiceInfo" label-width="80px" label-position="left">
          <el-form-item label="机构编号" prop="agentId" v-if="isInstitution" :rules="[{
            required: isInstitution,
            message: '请输入机构编号',
            trigger: 'blur'
          }]">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.agentId" :disabled="isInvoiceInfoEditeDisable"></el-input>
          </el-form-item>
          <el-form-item label="发票面值" prop="inputAgentInvoiceAmount">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.inputAgentInvoiceAmount" :disabled="isInvoiceInfoEditeDisable" @change="settInputAgentTax"></el-input>
          </el-form-item>
          <el-form-item label="发票代码" prop="inputAgentInvoiceCode">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.inputAgentInvoiceCode" :disabled="isInvoiceInfoEditeDisable" placeholder="发票左上角编码"></el-input>
          </el-form-item>
          <el-form-item label="发票号" prop="inputAgentInvoiceNo">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.inputAgentInvoiceNo" :disabled="isInvoiceInfoEditeDisable" placeholder="发票右上角编码"></el-input>
          </el-form-item>
          <el-form-item label="税率" prop="inputAgentTaxRatio">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.inputAgentTaxRatio" :disabled="isInvoiceInfoEditeDisable" @change="settInputAgentTax">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="税额" prop="inputAgentTax">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.inputAgentTax" disabled></el-input>
          </el-form-item>
          <el-form-item label="开票时间" prop="inputAgentInvoiceTime">
            <el-date-picker
              class="invoice-dialog-form-item"
              v-model="invoiceInfo.inputAgentInvoiceTime"
              type="date"
              placeholder="选择日期"
              :pickerOptions="{
                disabledDate(time) {
                  return time.getTime() > Date.now() - 8.64e6
                }
              }"
              value-format="yyyy-MM-dd"
              :disabled="isInvoiceInfoEditeDisable">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发票内容" prop="inputAgentContent">
            <el-input class="invoice-dialog-form-item" type="textarea" v-model="invoiceInfo.inputAgentContent" :disabled="isInvoiceInfoEditeDisable"></el-input>
          </el-form-item>
          <el-form-item label="快递单号" prop="inputAgentTrackingNo">
            <el-input class="invoice-dialog-form-item" v-model="invoiceInfo.inputAgentTrackingNo" :disabled="isInvoiceInfoEditeDisable"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="inputInvoiceRemark">
            <el-input class="invoice-dialog-form-item" type="textarea" placeholder="选填" v-model="invoiceInfo.inputInvoiceRemark" :disabled="isInvoiceInfoEditeDisable"></el-input>
          </el-form-item>
          <el-form-item label="发票照片" prop="AgentInvoiceImg">
            <VueImgInputer
              v-model="invoiceInfo.AgentInvoiceImg"
              theme="light"
              accept="image/*"
              @onChange="handleUpload('invoicePic')"
              v-loading="isPicUploading"
              placeholder="点击上传"
              :max-size="picMaxSize"
              :imgSrc="invoicePicPath"
              :readonly="isInvoiceInfoEditeDisable && isCheck"></VueImgInputer>
            <div style="cursor: pointer; text-decoration: underline;" v-if="invoicePicPath" @click="invoiceImgDialogVisible = true">点击查看大图</div>
            <div style="color: red;line-height: 28px;"><span style="vertical-align: top;">注：</span><span style="display: inline-block;">发票图片不得超过3M<br/>普票拍发票联，专票拍抵扣联</span></div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="invoiceInfoDialogVisible = false" >取 消</el-button>
        <el-button type="primary" v-if="!isInvoiceInfoEditeDisable || !isCheck" @click="invoiceInfoSubmitClick">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 发票图片预览dialog -->
    <el-dialog
      :visible.sync="invoiceImgDialogVisible"
      width="50%"
      center>
      <img style="width: 100%;" :src="invoicePicPath">
    </el-dialog>
    <el-dialog v-if="multiDialogVisible" :visible.sync="multiDialogVisible" title="批量导入" width="500px" :close-on-click-modal="false">
      <el-button size="small" style='margin-right: 20px' type="primary" @click="download()">下载模板文件</el-button>
      <input type="file" id="file" @change="getFile($event)" style="display:none"/>
      <el-button type="primary" plain size="small" class="check" @click="getMultiFiles()">批量导入</el-button>
      <el-col v-if="multiFileName !== ''" class="hasSelect">
        <span>已选择: {{ multiFileName }}</span>
        <i class="el-icon-remove removeIcon" @click="removeFile"></i>
      </el-col>
      <div slot="footer">
        <el-button type="primary" size="small" @click="multiInvoice" :loading="buttonLoading">确认</el-button>
        <el-button size="small" @click="multiDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量导入完成" :visible.sync="importDialogVisible" center width="500px">
      <p class="marginBtm">成功{{ this.successNum }}条，失败{{ this.failNum }}条</p>
      <el-table border size="small" :data="failData">
        <el-table-column prop="line" label="行数" width="70" align="center"></el-table-column>
        <el-table-column prop="invoiceNo" label="发票编号" width="120" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="70" align="center"></el-table-column>
        <el-table-column prop="reason" label="失败原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import { uploadInvoiceImage, queryAgentInvoiceList, inputAgentInvoice, updateInvoice, batchInputInvoice, deleteInvoice, listCustomerInvoice, exportCustomerInvoice } from '@/api/settle'
import api from '@/api/index'
const selectFn = {
  listCustomerInvoice, queryAgentInvoiceList
}
export default {
  name: 'ProfitInvoice',
  components: {
    VueImgInputer
  },
  data () {
    const twoDecimalReg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startDate: '',
        endDate: '',
        FState: ''
      },
      creatTime: '',
      status: '',
      tableLoading: false,
      invoiceList: [],
      totalAmountCount: {},
      invoiceInfoDialogVisible: false,
      invoiceInfoDialogLoading: false,
      invoiceInfoRules: {
        inputAgentInvoiceAmount: [
          { required: true, message: '请输入正确的发票面值', trigger: 'blur' },
          { pattern: twoDecimalReg, message: '发票面值最多2位小数' }
        ],
        inputAgentInvoiceCode: [
          { required: true, message: '请输入发票代码', trigger: 'blur' },
          { max: 12, message: '请输入不超过12位的发票代码', trigger: 'blur' }
        ],
        inputAgentInvoiceNo: [
          { required: true, message: '请输入发票号', trigger: 'blur' },
          { len: 8, message: '请输入8位的发票号', trigger: 'blur' }
        ],
        inputAgentTaxRatio: [
          { required: true, message: '请输入正确的税率', trigger: 'blur' },
          { pattern: twoDecimalReg, message: '税率最多2位小数' }
        ],
        inputAgentTax: [
          { required: true, message: '请输入发票面值与税率以计算税额', trigger: 'blur' },
          { pattern: twoDecimalReg, message: '税额最多2位小数' }
        ],
        inputAgentInvoiceTime: [
          { required: true, message: '请选择开票时间' }
        ],
        inputAgentContent: [
          { required: true, message: '请输入发票内容', trigger: 'blur' },
          { max: 20, message: '请输入不超过20位的发票内容', trigger: 'blur' }
        ],
        inputAgentTrackingNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          { max: 20, message: '请输入不超过20位的快递单号', trigger: 'blur' }
        ],
        AgentInvoiceImg: [
          { required: true, message: '请上传发票照片' }
        ]
      },
      invoiceInfo: {
        inputAgentInvoiceAmount: '',
        inputAgentInvoiceCode: '',
        inputAgentInvoiceNo: '',
        inputAgentTaxRatio: '',
        inputAgentTax: '',
        inputAgentInvoiceTime: '',
        inputAgentContent: '',
        inputAgentTrackingNo: '',
        inputInvoiceRemark: '',
        AgentInvoiceImg: '',
        fId: '',
        agentId: ''
      },
      isPicUploading: false,
      invoicePicPath: '',
      invoiceImgDialogVisible: false,
      isInvoiceInfoEditeDisable: false,
      picMaxSize: 1024 * 3,
      multiDialogVisible: false, // 批量导入弹窗显示
      multiFile: '', // 批量文件
      multiFileName: '', // 批量文件名
      buttonLoading: false, // 批量提交按钮
      isCheck: true, // 编辑发票信息
      importDialogVisible: false, // 批量导入结果
      successNum: 0, // 导入成功数量
      failNum: 0, // 导入失败数量
      failData: [], // 导入失败发票数组
      isInstitution: this.$store.getters.roleId === 10,
      customerId: '', // 机构号
      export_form: {
        moduleCode: 8,
        moduleName: '发票',
        menuName: '发票信息'
      },
      exportLoading: false
    }
  },
  mounted () {
    this.searchClick()
  },
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.searchInfo.startDate = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endDate = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.FState = this.status || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = this.isInstitution
        ? Object.assign(this.searchInfo, this.paginations, { customerId: this.customerId })
        : Object.assign(this.searchInfo, this.paginations)
      this.getQueryAgentInvoiceList()
    },
    /**
     * 发票录入按钮点击
     */
    invoiceEntryCilck () {
      // console.log('发票录入点击')
      this.resetInvoiceInfo()
      this.isInvoiceInfoEditeDisable = false
      this.invoiceInfoDialogVisible = true
    },
    /**
     * 根据发票面值和税率计算税额
     */
    settInputAgentTax () {
      if (!this.isInvoiceInfoEditeDisable && this.invoiceInfo.inputAgentInvoiceAmount && this.invoiceInfo.inputAgentTaxRatio) {
        // 税额  = 发票面值/（1+税率）* 税率
        const ratio = this.invoiceInfo.inputAgentTaxRatio / 100
        this.invoiceInfo.inputAgentTax = parseFloat(Number(this.invoiceInfo.inputAgentInvoiceAmount / (1 + ratio) * ratio).toFixed(2))
      }
    },
    /**
     * 上传图片
     * @param  {string} type 上传图片的种类
     */
    handleUpload (type) {
      this.isPicUploading = true
      const reader = new FileReader()
      reader.readAsDataURL(this.invoiceInfo.AgentInvoiceImg)
      reader.onload = () => {
        let file = reader.result
        this.invoicePicPath = file
        file = file.split('base64,')
        let data = {
          base64pic: file[1],
          filename: this.invoiceInfo.AgentInvoiceImg.name
        }
        data = qs.stringify(data)
        uploadInvoiceImage(data).then(response => {
          this.isPicUploading = false
          console.log(response)
          if (parseInt(response.error_code) === 0) {
            this.invoiceInfo.AgentInvoiceImg = response.imagePath
            this.invoicePicPath = response.showPath
            this.$message({
              message: '发票图片上传成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      }
    },
    /**
     * 录入确定按钮点击
     */
    invoiceInfoSubmitClick () {
      console.log('录入确定按钮点击')
      this.$refs.invoiceInfoform.validate((valid) => {
        if (valid) {
          const info = Object.assign({}, this.invoiceInfo)
          info.inputAgentInvoiceAmount = Number(info.inputAgentInvoiceAmount * 100).toFixed(0)
          info.inputAgentTaxRatio = Number(info.inputAgentTaxRatio * 10000).toFixed(0)
          info.inputAgentTax = Number(info.inputAgentTax * 100000000).toFixed(0)
          this.formatParams(info)
          // 如果没有fId说明是新增
          if (this.invoiceInfo.fId === '') {
            this.inputAgentInvoice(info)
          } else {
            this.editAgentInvoice(info)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * 记录查看按钮点击
     */
    handleInfo (index, row, scope) {
      console.log(`index: ${index}, row: `, row)
      this.resetInvoiceInfo()
      this.invoiceInfo.inputAgentInvoiceAmount = row.invoiceAmountStr
      this.invoiceInfo.inputAgentInvoiceCode = row.invoiceCode
      this.invoiceInfo.inputAgentInvoiceNo = row.invoiceNo
      this.invoiceInfo.inputAgentTaxRatio = row.taxRateStr
      this.invoiceInfo.inputAgentTax = row.taxAmountStr
      this.invoiceInfo.inputAgentInvoiceTime = row.createTime
      this.invoiceInfo.inputAgentContent = row.incoiceContent
      this.invoiceInfo.inputAgentTrackingNo = row.trackNum
      this.invoiceInfo.inputInvoiceRemark = row.remark
      // this.invoiceInfo.agentId = row.fAgentId
      this.invoicePicPath = row.image
      this.isInvoiceInfoEditeDisable = true
      this.invoiceInfoDialogVisible = true
      // 如果是编辑，增加发票id
      // if (!this.isCheck) {
      //   this.invoiceInfo.fId = row.fId
      // }
    },
    /**
     * 重置发票信息
     */
    resetInvoiceInfo () {
      this.invoiceInfo = {
        agentId: '',
        inputAgentInvoiceAmount: '',
        inputAgentInvoiceCode: '',
        inputAgentInvoiceNo: '',
        inputAgentTaxRatio: '',
        inputAgentTax: '',
        inputAgentInvoiceTime: '',
        inputAgentContent: '',
        inputAgentTrackingNo: '',
        inputInvoiceRemark: '',
        AgentInvoiceImg: '',
        fId: ''
      }
      this.invoicePicPath = ''
    },
    /**
     * 删除提交参数中的空字段
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 获取发票列表
     */
    getQueryAgentInvoiceList () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      const url = this.isInstitution ? 'listCustomerInvoice' : 'queryAgentInvoiceList'
      selectFn[url](params).then(response => {
        this.loading = false
        console.log('queryAgentInvoiceList response:', response)
        if (parseInt(response.code) === 0) {
          this.invoiceList = response.data.list
          this.totalAmountCount = {
            totalAudtiAmount: response.data.auditAmountTotalStr,
            totalInpAmount: response.data.inputAmountTotalStr
          }
          this.paginations.count = response.data.totalCount
          // this.$message({
          //   message: response.error_msg,
          //   type: 'success'
          // })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 发票录入
     */
    inputAgentInvoice (info) {
      this.invoiceInfoDialogLoading = true
      console.log(info)
      const params = qs.stringify(info)
      console.log(params)
      inputAgentInvoice(params).then(response => {
        this.invoiceInfoDialogLoading = false
        console.log('queryAgentInvoiceList response:', response)
        if (response.error_code === '0') {
          this.invoiceInfoDialogVisible = false
          this.searchClick()
          this.$message({
            message: response.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    // 发票编辑
    editAgentInvoice (info) {
      this.invoiceInfoDialogLoading = true
      const params = qs.stringify(info)
      updateInvoice(params).then(response => {
        this.invoiceInfoDialogLoading = false
        console.log('queryAgentInvoiceList response:', response)
        if (response.error_code === '0') {
          this.invoiceInfoDialogVisible = false
          this.searchClick()
          this.$message({
            message: response.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    // 批量录入发票
    multiInvoiceEntry () {
      this.buttonLoading = false
      this.multiDialogVisible = true
      this.multiFile = ''
      this.multiFileName = ''
    },
    // 上传文件
    getMultiFiles () {
      // eslint-disable-next-line no-undef
      this.$jquery('#file').click()
    },
    // 删除已上传文件
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    /**
       * @description 选择文件
       */
    getFile (event) {
      if (event.target.files[0].type !== 'application/vnd.ms-excel') {
        this.$message({
          message: '请上传.xls格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 3) {
        this.$message({
          message: '文件大小不得大于3M，请重新上传！',
          type: 'warning'
        })
        return
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    /**
       * @description 批量导入提交
       */
    multiInvoice () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      this.buttonLoading = true
      const data = new FormData()
      data.append('multipartFile', this.multiFile)
      batchInputInvoice(data).then((data) => {
        this.buttonLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.successNum = data.success_num
          if (data.fail_num === 0) {
            this.$message({
              showClose: true,
              message: data.error_msg + '，成功导入' + data.success_num + '条',
              type: 'success'
            })
          } else {
            this.importDialogVisible = true
            this.failNum = data.fail_num
            this.failData = data.result
          }
          this.multiDialogVisible = false
          this.status = '3'
          this.searchClick(false)
        }
      })
    },
    // 查看发票
    handleCheck (index, row) {
      this.isCheck = true
      this.handleInfo(index, row)
    },
    // 编辑发票
    handleEdit (index, row) {
      this.isCheck = false
      this.handleInfo(index, row)
    },
    // 删除
    handleRemove (index, row) {
      const that = this
      this.$confirm('是否确认删除该发票', '提示', {}).then(() => {
        const data = qs.stringify({ fId: row.fId })
        deleteInvoice(data).then(data => {
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getQueryAgentInvoiceList()
          } else {
            that.$message({
              message: data.error_msg,
              type: 'warning'
            })
          }
        })
      })
    },
    /**
       * 批量模板下载
       */
    download () {
      var p = api.host
      window.location.href = p + 'agent-profit/download-invoice-template.do'
    },
    exportInvoice () {
      this.searchInfo.startDate = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endDate = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.FState = this.status || ''
      this.searchInfo.customerId = this.customerId || ''
      this.exportLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, this.export_form))
      exportCustomerInvoice(params).then(res => {
        this.exportLoading = false
        if (res.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.error_msg,
            type: 'error'
          })
        }
      })
    }
  },
  computed: {},
  filters: {}
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.invoice-dialog-form-item {
  width: 260px;
}
.hasSelect{
    font-size: 15px;
    margin-top: 20px;
}
.hasSelect span{
    float: left;
    margin-bottom: 20px;
    line-height: 30px;
    display: inline-block;
    max-width: 430px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.hasSelect .removeIcon{
    color:#F56C6C;
    line-height: 30px;
    cursor: pointer;
    margin-left: 10px;
}
    .marginBtm{
        margin-bottom: 10px;
    }
</style>
